import { FilterInfoSticky } from "@faire/retailer-visitor-shared/components/Filters/FilterInfoSticky";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { LoggedOutSuppliersPageFilterSidebar } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageFiltersSidebar/LoggedOutSuppliersPageFiltersSidebar";
import { LoggedOutSuppliersPageFilterStoreProvider } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/LoggedOutSuppliersPageFilterStoreProvider";
import { useLoggedOutSuppliersPageUPLT } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/useLoggedOutSuppliersPageUPLT";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import React from "react";

import { LoggedOutSuppliersPageBrandResults } from "./Components/LoggedOutSuppliersPageBrandResults/LoggedOutSuppliersPageBrandResults";

const PAGE_JS_EXECUTED_MARK = markPageJsExecuted();

export const LoggedOutSuppliersPageResults: React.FC<{
  scrollToBrandsSection: () => void;
}> = ({ scrollToBrandsSection }) => {
  return (
    <LoggedOutSuppliersPageFilterStoreProvider>
      <LoggedOutSuppliersPageResultsBase
        scrollToBrandsSection={scrollToBrandsSection}
      />
    </LoggedOutSuppliersPageFilterStoreProvider>
  );
};

const LoggedOutSuppliersPageResultsBase: React.FC<{
  scrollToBrandsSection: () => void;
}> = ({ scrollToBrandsSection }) => {
  const loadTimingRef = useLoggedOutSuppliersPageUPLT(PAGE_JS_EXECUTED_MARK);

  return (
    <Flex className="w-full px-4 lg:px-12">
      <LoggedOutSuppliersPageFilterSidebar
        scrollToBrandsSection={scrollToBrandsSection}
      />
      <Column flex={1} gap="3x">
        <FilterInfoSticky name={FilterName.SUPPLIERS} />
        <div data-test-id="logged-out-suppliers-brand-list">
          <LoggedOutSuppliersPageBrandResults loadTimingRef={loadTimingRef} />
        </div>
      </Column>
    </Flex>
  );
};
